<div class="ft-monthly-calendar-day"
     (click)="inactive ? $event.stopPropagation() : null"
     [class.-month-range_start]="monthRangeStart"
     [class.-month-range]="monthRange"
     [class.-month-range_end]="monthRangeEnd"
     [class.-hovered-range_start]="hoveredRangeStart"
     [class.-hovered-range]="hoveredRange"
     [class.-hovered-range_end]="hoveredRangeEnd"
     [class.-focused]="focused"
     [class.-disabled]="disabled"
     [class.-inactive]="inactive"
     [class.-available]="available"
     [class.-selected]="selected"
     [class.-range]="range"
     [class.-range_end]="rangeEnd"
     [class.-range_start]="rangeStart"
     [class.-suggested]="suggested"
     [class.-static]="static">
    <span class="ft-monthly-calendar-day_date">
        {{ dateRef?.day }}
    </span>
</div>
